import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * Our font-size tokens (tailwind.config.ts > theme.extend.fontSize). tailwind-merge only knows
 * Tailwind's own names (text-sm, text-lg, ...); anything else under `text-` is treated as a text
 * COLOUR. Until 21-Oct-2026 that silently removed `text-white` whenever `text-body` / `text-caption`
 * came later in the same cn() call - every <Button variant="primary"> rendered dark text on blue.
 * Keep this list in sync with tailwind.config.ts (the ship script reads it from there).
 */
const FONT_SIZE_TOKENS = ["display-lg", "display-md", "display-sm", "title", "body", "caption", "micro"];

const twMerge = extendTailwindMerge({
  extend: { classGroups: { "font-size": [{ text: FONT_SIZE_TOKENS }] } },
});

/**
 * Merge Tailwind classes intelligently.
 * - `clsx` handles conditional/array/object class lists
 * - `twMerge` resolves conflicting Tailwind classes (later wins)
 *
 * Usage:
 *   cn("px-2 py-1", isActive && "bg-brand-500", "px-4")
 *   -> "py-1 bg-brand-500 px-4"
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}